import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { FlagIcon } from '@/components/ui/flag-icon'
import { useThemeStore, LANGUAGES } from '@/stores/theme-store'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export function LanguageToggle() {
  const { language, setLanguage } = useThemeStore()

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button 
              variant="ghost" 
              size="icon"
              className="hover:bg-accent"
            >
              <FlagIcon country={language} className="w-7 h-5" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>
          {LANGUAGES[language].label}
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {Object.entries(LANGUAGES).map(([code, { label }]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code as keyof typeof LANGUAGES)}
            className={cn(
              "flex items-center justify-between cursor-pointer gap-3 py-2.5",
              language === code && "bg-accent"
            )}
          >
            <span className="flex items-center gap-3">
              <FlagIcon country={code as 'th' | 'en' | 'lo' | 'km'} className="w-6 h-4" />
              <span className="text-sm font-medium">{label}</span>
            </span>
            {language === code && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
